
/**
 *      Data-driven UI logic for the search facets
 *
 *      @author Irina Patrikeeva <irina.i.ipatrikeeva@nasa.gov>
 *
 *      Created on 07/27/2018
 *      Modified on 08/01/2018
 */


/**
 * Display search facets using Search API aggregations
 * @param response
 */
function displaySearchFacets( response ) {

    // Show facet panel
    var parentId = 'facets',
        aggs,
        bucket,
        typeArray,
        filters,
        types,
        group,
        multifaceted,
        dateFilter,
        isSingleType = false;

    $('#' + parentId ).show();
    // Hide category arrows in the facet panel
    $('#showMore').hide();
    $('#showLess').hide();

    // Search URL can consists of zero of more parameters: filters, types, group with or without multi-faceted global flag

    filters = doesURLContainFilterParameterOnly(); // looks for a substring "&filters=", may contain the date filter
    types = getTypeStringFromURL( Backbone.history.getFragment() ); // returns the string between "&type=" substring and the next "&" character
    group = getGroupStringFromURL(); // returns the string between "&group=" substring and the next "&" character
    multifaceted = App.globalState.multifacets; // global multi-faceted flag
    dateFilter = App.globalState.dateFilter; // global date filter value

    // Check if only one type is in the type parameter in the URL
    if ( types ) {
        typeArray = types.split(",");
        if ( typeArray && typeArray.length === 1 ) {
            isSingleType = true;
        }
    }

    // Case 1: No filters, no types, no group : display multi-faceted search interface
    // search?q={query}

    var case1 = ! filters && ! types && ! group;

    if ( case1 ) {
        // console.log("Case 1: No filters, no types, no group : display multi-faceted search interface");
        $( '#current-filters-title').hide();
        $( '#refine-types-button' ).show();
        displayInitialDataTypes( response );
    }

    // Case 2A: No filters, single type, no group, multi-faceted flag is true : display multi-faceted search interface and check the type checkbox
    // search?q={query}&type={type}

    var case2a = ! filters && isSingleType && ! group && multifaceted;

    if ( case2a ) {

        // console.log("Case 2a: No filters, single type, no group, multi-faceted flag is true : display multi-faceted search interface and check the type checkbox");
        $( '#current-filters-title').hide();
        $('#refine-types-button').show();

        // Construct a new aggregations object that consists of the single type
        if ( response && response.hits ) {
            aggs = {};
            aggs.types = {};
            aggs.types.buckets = [];
            bucket = {};
            bucket.key = types;
            bucket.doc_count = response.hits.total;
            aggs.types.buckets.push( bucket );
            response.aggregations = aggs;
        }
        displayInitialDataTypes( response );
    }

    // Case 2B: No filters, single type, no group, multi-faceted flag is false : display single-type search interface and type aggregations
    // search?q={query}&type={type}

    var case2b = ! filters && isSingleType && ! group && ! multifaceted;
    if ( case2b ) {

        // Show current filters title
        $( '#current-filters-title').show();
        $('#refine-types-button').hide();

        displayCurrentFilters();
        displayAvailableFilters( response );
    }

    // Case 3: No filters, multiple types, no group : display multi-faceted search interface and check the types checkboxes
    // search?q={query}&type={type1},{type2}

    var case3 = ! filters && types && ! isSingleType && ! group;

    if ( case3 ) {

        $( '#current-filters-title').hide();
        $( '#refine-types-button' ).show();
        displayInitialDataTypes( response );
    }

    // Case 4: Date filter, no types, no group : display date filter and multi-faceted search interface
    // search?q={query}&filters=indexed|gt|{date};

    var case4 = filters && dateFilter !== "all" && ! types && ! group;
    if ( case4 ) {
        $( '#current-filters-title').show();
        $( '#refine-types-button' ).show();

        setGlobalFilters( response );
        displayCurrentFilters();
        displayInitialDataTypes( response );

    }

    // Case 5A: Date filter (and optionally other filters), single type, no group, multi-faceted flag is true : display date filter, multi-faceted search interface and check the type checkbox
    // search?q={query}&type={type}&filters=indexed|gt|{date};
    var case5a = filters && dateFilter !== "all" && isSingleType && ! group && multifaceted;
    if ( case5a ) {
        $( '#current-filters-title').show();

        // Add date filter selected to the URL
        if ( isGlobalDateFilterSet() ) {
            addDateFilterToURL( false );
        }

        // Construct a new aggregations object that consists of the single type
        if ( response && response.hits ) {

            aggs = {};
            aggs.types = {};
            aggs.types.buckets = [];
            bucket = {};
            bucket.key = types;
            bucket.doc_count = response.hits.total;
            aggs.types.buckets.push( bucket );
            response.aggregations = aggs;

        }

        displayCurrentFilters();

        $( '#refine-types-button' ).show();
        displayInitialDataTypes( response );

    }

    // Case 5B: Date filter, single type, no group, multi-faceted flag is false : display date filter, single-type search interface and type aggregations
    // search?q={query}&type={type}&filters=indexed|gt|{date};
    var case5b = filters && dateFilter !== "all" && isSingleType && ! group && ! multifaceted;

    if ( case5b ) {
        $( '#current-filters-title').show();
        // Add date filter selected to the URL
        if ( isGlobalDateFilterSet() ) {
            addDateFilterToURL( false );
        }

        displayCurrentFilters();
        $( '#refine-types-button' ).hide();
        displayAvailableFilters( response );
    }

    // Case 6: Date filter, multiple types, no group : display date filter, multi-faceted search interface and check the types checkboxes
    // search?q={query}&type={type1},{type2}&filters=indexed|gt|{date};

    var case6 = filters && dateFilter !== "all" && types && ! isSingleType && ! group;

    if ( case6 ) {

        $( '#current-filters-title').show();

        // Add date filter selected to the URL
        if ( isGlobalDateFilterSet() ) {
            addDateFilterToURL( false );
        }

        displayCurrentFilters();

        $( '#refine-types-button' ).show();
        displayInitialDataTypes( response );

    }

    // Case 7: Filters, single type, no group, multi-faceted flag is false : display single-type search interface, its selected filters and available type aggregations
    // search?q={query}&type={type}&filters={field}|{op}|{value};

    var case7 = filters && dateFilter === "all" && types && isSingleType && ! group && ! multifaceted;
    if ( case7 ) {
        $( '#current-filters-title').show();
        displayCurrentFilters();
        $( '#refine-types-button' ).hide();
        displayAvailableFilters( response );
    }

    // Case 8: No filters, no types, group : display multi-faceted search interface with group types, highlight the group in the menu
    // search?q={query}&group={group}

    var case8 = ! filters && ! types && group;
    if ( case8 ) {

        $( '#current-filters-title').hide();
        $( '#refine-types-button' ).show();
        displayInitialDataTypes( response );
    }

    // Case 9A: No filters, single type, group, multi-faceted flag is true : display multi-faceted search interface with group types and check the type checkbox, highlight the group in the menu
    // search?q={query}&type={type}&group={group}
    var case9a = ! filters && isSingleType && group && multifaceted;
    if ( case9a ) {
        $( '#current-filters-title').hide();
        $( '#refine-types-button' ).show();

        // Construct a new aggregations object that consists of the single type
        if ( response && response.hits ) {
            aggs = {};
            aggs.types = {};
            aggs.types.buckets = [];
            bucket = {};
            bucket.key = types;
            bucket.doc_count = response.hits.total;
            aggs.types.buckets.push( bucket );
            response.aggregations = aggs;
        }

        displayInitialDataTypes( response );
    }


    // Case 9B: No filters, single type, group, multi-faceted flag is false : display single-type search interface and type aggregations, highlight the group in the menu
    // search?q={query}&type={type}&group={group}

    var case9b = ! filters && isSingleType && group && ! multifaceted;
    if ( case9b ) {
        $( '#current-filters-title').show();
        $( '#refine-types-button' ).hide();

        displayCurrentFilters();
        displayAvailableFilters( response );
    }

    // Case 10: No filters, multiple types, group : display multi-faceted search interface with group and check the types checkboxes, highlight the group in the menu
    // search?q={query}&type={type1},{type2}&group={group}
    var case10 = ! filters && types && ! isSingleType && group;
    if ( case10 ) {
        $( '#current-filters-title').hide();
        $( '#refine-types-button' ).show();

        displayInitialDataTypes( response );
    }

    // Case 11: Date filter, no types, group : display date filter and multi-faceted search interface with group, highlight the group in the menu
    // search?q={query}&filters=indexed|gt|{date};&group={group}
    var case11 = filters && dateFilter !== "all" && ! types && group;
    if ( case11 ) {

        $( '#current-filters-title').show();
        $( '#refine-types-button' ).show();

        // Set global filters and display them
        setGlobalFilters( response );

    }

    // Case 12A: Date filter, single type, group, multi-faceted flag is true : display date filter, multi-faceted search interface with group, check the type checkbox, highlight the group in the menu
    // search?q={query}&type={type}&filters=indexed|gt|{date};&group={group}

    var case12a = filters && dateFilter !== "all" && types && isSingleType && group && multifaceted;
    if ( case12a ) {

        $( '#current-filters-title').show();
        $( '#refine-types-button' ).show();

        // Construct a new aggregations object that consists of the single type
        if ( response && response.hits ) {
            aggs = {};
            aggs.types = {};
            aggs.types.buckets = [];
            bucket = {};
            bucket.key = types;
            bucket.doc_count = response.hits.total;
            aggs.types.buckets.push( bucket );
            response.aggregations = aggs;
        }

        // Set global filters and display them
        setGlobalFilters( response );

        displayCurrentFilters();
        displayInitialDataTypes( response );
    }

    // Case 12B: Date filter, single type, group, multi-faceted flag is false : display date filter, single-type search interface and type aggregations, highlight the group in the menu
    // search?q={query}&type={type}&filters=indexed|gt|{date};&group={group}
    var case12b = filters && dateFilter !== "all" && types && isSingleType && group && ! multifaceted;

    if ( case12b ) {

        $( '#current-filters-title').show();
        $( '#refine-types-button' ).hide();

        displayCurrentFilters();
        displayAvailableFilters( response );

    }

    // Case 13: Date filter, multiple types, group : display date filter, multi-faceted search interface with group and check the types checkboxes, highlight the group in the menu
    // search?q={query}&type={type1},{type2}&filters=indexed|gt|{date};&group={group}

    var case13 = filters && dateFilter !== "all" && types && ! isSingleType && group;
    if ( case13 ) {

        $( '#current-filters-title').show();
        $( '#refine-types-button' ).show();

        displayCurrentFilters();
        displayInitialDataTypes( response );

    }
    // Case 14: Filters, single type, group, multi-faceted flag is false : display single-type search interface, its selected filters and available type aggregations, highlight the group in the menu
    // search?q={query}&type={type}&filters={field}|{op}|{value};&group={group}
    var case14 = filters && dateFilter === "all" && types && isSingleType && group && ! multifaceted;
    if ( case14 ) {

        $( '#current-filters-title').show();
        $( '#refine-types-button' ).hide();

        displayCurrentFilters();
        displayAvailableFilters( response );

    }

}